<template>
  <el-popover placement="top-start"
              :show-after="300"
              :hide-after="0"
              popper-class="sakura-port-popover"
              :popper-options="{
      modifiers: [
        {
          name: 'preventOverflow',
          options: {
            boundary: 'viewport'
          }
        },
        {
          name: 'flip',
          options: {
            fallbackPlacements: ['top', 'right', 'left']
          }
        }
      ]
    }" trigger="hover"
              :disabled="!popover || isFanout" @after-enter="initInfoHandle" >
    <port-lan-info :port="port" :showProfile="calcShowProfile" v-model:received="received"
                   v-model:transmitted="transmitted" ref="lanInfoRef"></port-lan-info>
    <template #reference>
      <div class="sakura-port-lan" @click="activeHandler">
        <!-- Top Right -->
        <img class="port-status port-selected" src="/static/images/port/selected.png" v-if="value && !isEnabledTu" />
        <!-- Trunk -->
        <div class="port-status port-tu" v-if="tu === 2 && isEnabledTu">
          <img src="/static/images/port/trunk.png" style="width: 9px;height: 9px;" />
        </div>
        <img class="port-status port-tu" src="/static/images/port/selected.png" v-if="tu === 1 && isEnabledTu" />


        <div class="lan-content" :class="[statusClass, borderStatusClass, invert ? 'lan-invert' : '']">
          <template v-if="isHdmi">
            <div class="hdmi-view">
              <div class="rect-view" :style="{ backgroundColor: calcColor }"></div>
              <div class="trapezoid-view">
                <div class="trapezoid-box">
                  <div class="triangle-top" :style="{ borderColor: `'${calcColor}' transparent` }"></div>
                  <div class="triangle-top-border"></div>
                  <div class="small-rect-view" :style="{ backgroundColor: calcColor }"></div>
                  <div class="triangle-bottom" :style="{ borderColor: `transparent '${calcColor}'` }"></div>
                  <div class="triangle-bottom-border"></div>
                </div>
              </div>
              <div class="lan-font" :class="{ 'special-font': isSpecial }">
                <slot></slot>
              </div>
            </div>
          </template>
          <template v-else-if="isPlus">
            <div class="slot-view" :style="{ backgroundColor: calcColor }">
              <div class="lan-font" :class="{ 'special-font': isSpecial }">
                <slot></slot>
              </div>
            </div>
          </template>
        </div>
        <!-- Bottom Right -->
          <div class="port-status port-poe" v-if="showMode('poe')" :style="{ 'zIndex': getZIndex('poe') }">
            <img src="/static/images/port/PoE.png" />
          </div>
          <div class="port-status port-poe" v-if="showMode('poeDisabled')"
               :style="{ 'zIndex': getZIndex('poeDisabled') }">
            <img src="/static/images/port/PoE-disabled.png" />
          </div>

          <div class="port-status port-S" v-if="showMode('S')" :style="{ 'zIndex': getZIndex('S') }">
            <img src="/static/images/port/S.png" />
          </div>

          <div class="port-status port-Sa" v-if="showMode('S+')" :style="{ 'zIndex': getZIndex('S+') }">
            <img src="/static/images/port/S+.png" />
          </div>

          <div class="port-status port-S28" v-if="showMode('S28')" :style="{ 'zIndex': getZIndex('S28') }">
            <img src="/static/images/port/S28.png" />
          </div>

          <div class="port-status port-QSpuls" v-if="showMode('QS+')" :style="{ 'zIndex': getZIndex('QS+') }">
            <img src="/static/images/port/QSplus.png" />
          </div>
          <div class="port-status port-Q28" v-if="showMode('Q28')" :style="{ 'zIndex': getZIndex('Q28') }">
            <img src="/static/images/port/Q28.png" />
          </div>

          <div class="port-status port-S56" v-if="showMode('S56')" :style="{ 'zIndex': getZIndex('S56') }">
            <img src="/static/images/port/S56.png" />
          </div>

          <div class="port-status port-block" v-if="showMode('block')" :style="{ 'zIndex': getZIndex('block') }">
            <img src="/static/images/port/Block.png" />
          </div>

          <div class="port-status port-admin-down" v-if="showMode('adminDown')"
               :style="{ 'zIndex': getZIndex('adminDown') }">
            <img src="/static/images/port/admin-down.png" style="width: 4px;" />
          </div>

          <div class="port-status port-trunk" v-if="showMode('trunk')" :style="{ 'zIndex': getZIndex('trunk') }">
            <img src="/static/images/port/trunk.png" style="width: 9px;height: 9px;" />
          </div>

          <div class="port-status port-LAG" v-if="showMode('L') && lag" :style="{ 'zIndex': getZIndex('L') }"
               style="width: 20px;height: 20px;">
            <span class="f12" style="margin-top: 4px;">L<label>{{ lag }}</label></span>
          </div>

          <div class="port-status port-autoTrunk" v-if="showMode('autoTrunk')"
               :style="{ 'zIndex': getZIndex('autoTrunk') }" style="width: 20px;height: 20px;">
            <span class="f14" style="margin-top: 3px;">A</span>
          </div>

          <div class="port-status port-manualTrunk" v-if="showMode('manualTrunk') && showStatus('manualTrunk')"
               :style="{ 'zIndex': getZIndex('manualTrunk') }" style="width: 20px;height: 20px;">
            <span class="f14" style="margin-top: 3px;">M</span>
          </div>

          <div class="port-status port-fanout" v-if="showMode('fanout') && showStatus('fanout')"
               :style="{ 'zIndex': getZIndex('fanout') }" style="width: 20px;height: 20px;">
            <span class="f14" style="margin-top: 3px;">F</span>
          </div>

          <div class="port-status port-authorized" v-if="showMode('Authorized')"
               :style="{ 'zIndex': getZIndex('Authorized') }">
            <img src="/static/images/port/authorized.png" />
          </div>

          <div class="port-status port-unauthorized" v-if="showMode('Unauthorized')"
               :style="{ 'zIndex': getZIndex('Unauthorized') }">
            <img src="/static/images/port/unauthorized.png" />
          </div>

          <div class="port-status port-block-multicast" v-if="showMode('blockMulticast')"
               :style="{ 'zIndex': getZIndex('blockMulticast') }">
            <img src="/static/images/port/Block.png" />
          </div>
          <div class="port-status port-force-multicast" v-if="showMode('forceMulticast')"
               :style="{ 'zIndex': getZIndex('forceMulticast') }">
            <i class="el-icon-rank"></i>
          </div>

          <div class="port-status port-dynamic" v-if="showMode('dynamic')" :style="{ 'zIndex': getZIndex('dynamic') }">
            <img src="/static/images/port/dynamic.png" style="width: 20px;height: 20px;" />
          </div>

          <div class="port-status port-warning" v-if="showMode('warning')" :style="{ 'zIndex': getZIndex('warning') }">
            <img src="/static/images/port/Warning.gif" style="width: 15px;height: 15px;border-radius: 100%;" />
          </div>
        <!-- Bottom Left -->
        <div class="port-status port-more-type" v-if="showMoreMode('control')">
          <img src="/static/images/port/more-control.png" />
        </div>
        <div class="port-status port-more-type" v-if="showMoreMode('audio')">
          <img src="/static/images/port/more-audio.png" />
        </div>
        <div class="port-status port-more-type" v-if="showMoreMode('video')">
          <img src="/static/images/port/more-video.png" />
        </div>

        <!-- Top Left -->
        <div class="port-status port-vendor" v-if="!!calcVendor.vendor" :class="{
        'port-vendor-visionary': ['visionary', 'NUCLEUS', 'lightware'].includes(calcVendor.vendor),
        'port-vendor-kramer': ['kramer'].includes(calcVendor.vendor),
        'port-vendor-full': ['genelec'].includes(calcVendor.vendor),
        'port-vendor-round': ['GandD'].includes(calcVendor.vendor),
      }" style="z-index:30">
          <img :src="`/static/images/port/${calcVendor.vendor}.png`" />
        </div>

      </div>
    </template>
  </el-popover>
</template>



<script setup>
import {ref, computed, inject, getCurrentInstance} from 'vue'
import { ColorUtil } from '../../js/util'
import portLanInfo from './sakura-port-lan-info'

const { proxy } = getCurrentInstance();
const props = defineProps({
  popover: { type: Boolean, default: false },
  invert: { type: Boolean, default: false },
  port: { type: Number, default: 0 },
  value: { type: Boolean, default: false },
  isEnabled: { type: Boolean, default: true },
  hex: { type: String, default: '#409EFF' },
  lag: { type: [String, Number], default: '' },
  type: {
    type: String,
    default: 'hdmi',
    validator: value => ['hdmi', 'plus'].includes(value)
  },
  mode: {
    type: Array,
    default: () => []
  },
  status: {
    type: String,
    default: '',
    validator: value => ['', 'disabled', 'available'].includes(value)
  },
  borderStatus: {
    type: String,
    default: '',
    validator: value => ['', 'connected', 'connected-powered', 'error'].includes(value)
  },
  priority: {
    type: Array,
    default: () => []
  },
  isEnabledTu: {
    type: Boolean,
    default: false
  },
  tu: {
    type: Number,
    default: 0,
    validator: value => [0, 1, 2].includes(value)
  },
  vendor: {
    type: String,
    default: ''
  },
  config: {
    type: Object,
    default: () => ({})
  },
  detach: {
    type: Boolean,
    default: false
  },
  isFanout: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits(['port-click-fanout', 'port-click', 'update:tu', 'input', 'change'])

const network = inject('network', null)

const received = ref(false)
const transmitted = ref(false)
const visible = ref(false)

const isHdmi = computed(() => props.type === 'hdmi')
const isPlus = computed(() => props.type === 'plus')
const statusClass = computed(() => props.status ? `lan-${props.status}` : '')
const borderStatusClass = computed(() => props.borderStatus ? `lan-${props.borderStatus}` : '')
const isSpecial = computed(() => {
  return props.hex !== '#000000' && proxy.$sakura.contrastColor(props.hex) === '#000000'
})
const calcColor = computed(() => props.detach ? '#6E6E6E' : props.hex)

const calcVendor = computed(() => {
  const [vendorName, vendorType] = props.vendor.split(' ')
  return { vendor: vendorName, type: vendorType }
})

const calcMode = computed(() => props.isFanout ? ['fanout', ...props.mode] : props.mode)
const calcPriority = computed(() => ['fanout', ...props.priority])

function getZIndex(modeItem) {
  let zIndex = 10
  const arr = [...calcPriority.value].reverse()
  arr.some((item, index) => {
    if (item === modeItem) {
      zIndex += index
      return true
    }
  })
  return zIndex
}

function showStatus(name) {
  const currentZ = getZIndex(name)
  const allZ = calcMode.value.map(getZIndex)
  const [max] = [...allZ].sort((a, b) => b - a)
  return currentZ === max
}

function showMode(name) {
  const arr = ['autoTrunk', 'L', 'autoTrunk', 'manualTrunk', 'fanout'];


  const priority = [...calcPriority.value];

  if (props.isEnabledTu) {
    if (priority.length > 0) {
      return arr.includes(name) && priority.filter(item => calcMode.value.includes(item) && item === name).length
    } else return false
  } else {
    if (priority.length) {
      return priority.filter(item => calcMode.value.includes(item) && item === name).length
    } else return false
  }
}

const calcShowProfile = computed(() => {
  const arr = [
    showMode('autoTrunk') && showStatus('autoTrunk'),
    showMode('L') && props.lag,
    showMode('manualTrunk') && showStatus('manualTrunk')
  ]
  return arr.filter(Boolean).length === 0
})

function showMoreMode(typeVal) {
  return typeVal === calcVendor.value.type
}

function activeHandler() {
  if (props.isFanout) {
    emit('port-click-fanout')
  } else {
    emit('port-click')
    if (props.isEnabledTu) {
      let num = props.tu + 1
      if (num > 2) num = 0
      emit('update:tu', num)
    } else {
      if (props.isEnabled) {
        emit('input', !props.value)
        emit('change', !props.value)
      }
    }
    if (network?.updateUnitSelect) {
      network.updateUnitSelect()
    }
  }
}
const lanInfoRef = ref(null)
// Optional: `initInfoHandle` if needed for refs
function initInfoHandle() {
  lanInfoRef.value?.open()
}
</script>


<style lang="scss" scoped>
@use "@/css/base.scss" as *;
@use "@/css/mixin.scss" as *;

.sakura-port-lan {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
  cursor: pointer;
  user-select: none;
  position: relative;
  outline: none;

  .lan-content {
    position: relative;

    .hdmi-view {
      width: 20px;
      height: 63px;
      line-height: 63px;
      color: #656565;
      position: relative;
      overflow: hidden;

      .rect-view {
        width: 10px;
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        border: 2px solid #504b51;
        box-sizing: border-box;
        background: #2c262d;
      }

      .trapezoid-view {
        width: 10px;
        position: absolute;
        right: 3px;
        top: 0;
        bottom: 0;
        box-sizing: border-box;

        .trapezoid-box {
          position: relative;
          height: 100%;

          .triangle-top,
          .triangle-top-border {
            border-width: 0px 7px 7px 0px;
            border-style: solid;
            box-sizing: border-box;
            border-color: #2c262d transparent;
            position: absolute;
            top: 0;
            right: 2px;
            z-index: 3;
          }

          .small-rect-view {
            width: 10px;
            height: 49px;
            box-sizing: border-box;
            background: #2c262d;
            border-right: 2px solid #504b51;
            position: absolute;
            top: 7px;
          }

          .triangle-bottom,
          .triangle-bottom-border {
            border-width: 0px 0px 7px 7px;
            border-style: solid;
            box-sizing: border-box;
            border-color: transparent #2c262d;
            position: absolute;
            bottom: 0;
            right: 2px;
            z-index: 3;
          }

          .triangle-top-border,
          .triangle-bottom-border {
            right: 0;
            z-index: 2;
          }

          .triangle-top-border {
            border-color: #504b51 transparent;
          }

          .triangle-bottom-border {
            border-color: transparent #504b51;
          }
        }
      }

      .lan-font {
        color: #fff;
        text-align: center;
        position: absolute;
        right: 0;
        left: 0;
        padding-right: 3px;
      }
    }

    .slot-view {
      width: 76px;
      height: 39px;
      border: 2px solid #504b51;
      box-sizing: border-box;
      background: #2c262d;
      position: relative;

      .lan-font {
        color: #fff;
        line-height: 39px;
      }
    }

  }

  .lan-connected {
    .hdmi-view {
      .rect-view {
        border-color: #00D76F;
      }

      .lan-font {
        color: #fff;
      }

      .trapezoid-view .trapezoid-box {
        .small-rect-view {
          border-right: 2px solid #00D76F;
        }

        .triangle-top-border {
          border-color: #00D76F transparent;
        }

        .triangle-bottom-border {
          border-color: transparent #00D76F;
        }
      }
    }

    .slot-view {
      border: 2px solid #00D76F;

      .lan-font {
        color: #fff;
      }
    }
  }

  .lan-connected-powered {
    .hdmi-view {
      .rect-view {
        border-color: #409EFF;
      }

      .lan-font {
        color: #fff;
      }

      .trapezoid-view .trapezoid-box {
        .small-rect-view {
          border-right: 2px solid #409EFF;
        }

        .triangle-top-border {
          border-color: #409EFF transparent;
        }

        .triangle-bottom-border {
          border-color: transparent #409EFF;
        }
      }
    }

    .slot-view {
      border: 2px solid #409EFF;

      .lan-font {
        color: #fff;
      }
    }
  }

  .lan-error {
    .hdmi-view {
      .rect-view {
        border-color: #fc3858;
      }

      .lan-font {
        color: #fff;
      }

      .trapezoid-view .trapezoid-box {
        .small-rect-view {
          border-right: 2px solid #fc3858;
        }

        .triangle-top-border {
          border-color: #fc3858 transparent;
        }

        .triangle-bottom-border {
          border-color: transparent #fc3858;
        }
      }
    }

    .slot-view {
      border: 2px solid #fc3858;

      .lan-font {
        color: #fff;
      }
    }
  }

  .lan-disabled {
    .hdmi-view {
      .rect-view {
        background-color: #707070 !important;
      }

      .lan-font {
        color: #999 !important;
      }

      .trapezoid-view .trapezoid-box {
        .small-rect-view {
          background-color: #707070 !important;
        }

        .triangle-top {
          border-color: #707070 transparent !important;
        }

        .triangle-bottom {
          border-color: transparent #707070 !important;
        }
      }
    }

    .slot-view {
      background-color: #707070 !important;

      .lan-font {
        color: #999 !important;
      }
    }
  }

  .lan-available {
    .hdmi-view {
      .rect-view {
        background-color: #0B0B0B;
      }

      .lan-font {
        color: #fff;
      }

      .trapezoid-view .trapezoid-box {
        .small-rect-view {
          background-color: #0B0B0B;
        }

        .triangle-top {
          border-color: #0B0B0B transparent;
        }

        .triangle-bottom {
          border-color: transparent #0B0B0B;
        }
      }
    }

    .slot-view {
      background-color: #0B0B0B;

      .lan-font {
        color: #fff;
      }
    }
  }

  .lan-invert {
    transform: rotate(-180deg);

    .lan-font {
      transform: rotate(180deg);
    }
  }

  .port-status {
    @include wh(20px, 20px);
    @include inlineBlock();
    background-color: #fff;
    border-radius: 100%;
    text-align: center;
    position: relative;

    img,
    i {
      position: absolute;
      top: 50%;
      left: 50%;
      font-size: 12px;
      @include wh(12px, 12px);
      transform: translate(-50%, -50%);
    }
  }

  .port-selected,
  .port-tu {
    position: absolute;
    top: 20px;
    right: 8px;
    z-index: 10;
  }

  .port-poe,
  .port-S,
  .port-Sa,
  .port-S28,
  .port-QSpuls,
  .port-Q28,
  .port-S56,
  .port-block,
  .port-admin-down,
  .port-L,
  .port-LAG,
  .port-trunk,
  .port-authorized,
  .port-unauthorized,
  .port-autoTrunk,
  .port-manualTrunk,
  .port-fanout,
  .port-block-multicast,
  .port-force-multicast,
  .port-dynamic,
  .port-warning {
    position: absolute;
    bottom: 20px;
    right: 8px;
    z-index: 10;
  }

  .port-LAG,
  .port-autoTrunk,
  .port-manualTrunk,
  .port-fanout,
  .port-warning {
    line-height: 1;

    span {
      transform: scale(0.8);
      display: inline-block;
      font-weight: bold;
      color: #303639;
    }
  }

  .port-S,
  .port-Sa {
    img {
      width: 10px;
      height: 10px;
    }
  }

  .port-S28,
  .port-QSpuls,
  .port-Q28 {
    img {
      width: 80%;
      height: 80%;
    }
  }

  .port-S56 {
    img {
      width: 90%;
      height: 90%;
    }
  }

  .port-dynamic-special,
  .port-more-type {
    position: absolute;
    bottom: 20px;
    left: 8px;
    z-index: 10;
  }

  .port-vendor {
    position: absolute;
    top: 20px;
    left: 8px;
    z-index: 10;

    img {
      width: 18px;
      height: 14px;
    }
  }

  .port-no-vendor {
    background-color: #4E81C2;
  }


  .special-font {
    color: #000000;
  }

  .port-vendor-visionary {
    img {
      width: 15px;
      height: 15px;
    }
  }

  .port-vendor-kramer {
    img {
      width: 22px;
      height: 22px;
    }
  }

  .port-vendor-full {
    img {
      width: 22px;
      height: 22px;
    }
  }

  .port-vendor-round {
    img {
      width: 21px;
      height: 21px;
      border-radius: 50%;
    }
  }
}
</style>
